module.exports = __webpack_public_path__ + "static/img/main.ab148289.png";